import { useSelector } from "react-redux";
import { Backdrop } from "@mui/material";
import { DotsLoader } from "Components/Loader/Index";
import { Image } from "react-bootstrap";
import logo from 'Recursos/logo_genesis2.png';

export const BackdropGenesis = (props) => {
    const showBackdrop = useSelector((state) => state.ui.showBackdrop);

    return (
        <Backdrop
            className="vertical-align"
            sx={{
                position: 'relative',
                background: 'transparent',
                top: 0,
                width: '100%',
                color: '#0046ad',
                opacity: 0.5,
                display: !showBackdrop ? 'none' : '',
                height: '50vh'
            }}
            open={showBackdrop}
        >
            <div className="text-center">
                <h3 className="me-2">{props.label}</h3>
                {props.loader}
            </div>
        </Backdrop>
    );
}

export const BackdropInicio = () => {
    return (
        <div className="w-100 d-flex justify-content-center mt-4 mb-4 align-items-center p-5" style={{ minHeight: '80vh' }}>
            <BackdropGenesis
                loader={
                    <>
                        <Image src={logo} />
                        <DotsLoader />
                    </>
                }
            >
            </BackdropGenesis>
        </div>
    );
}